import store from '../redux/store';
import { openCart, addItem } from '../redux/cart/actions';

export default () => {
  const el = document.querySelector('[data-bcsf-overrides]');

  if (el) {
    const selectors = {
      addToCart: '[data-bcsf-override-add-to-cart]',
    };

    el.addEventListener('submit', (e) => {
      const form = e.target;
      if (form.querySelector(selectors.addToCart)) {
        e.preventDefault();
      }
    });

    el.addEventListener('click', (e) => {
      let targetElement = e.target;

      while (targetElement && targetElement !== e.currentTarget) {
        const addToCartElement = targetElement.closest(selectors.addToCart);
        
        if (addToCartElement) {
          e.preventDefault();
          e.stopPropagation();
          
          const data = JSON.parse(addToCartElement.dataset.jsonProps);
          const { measurements } = data;
          const variantId = document.getElementById(data.variantInputId).value;
          const variant = data.items.find((node) => String(node.variantId) === String(variantId));

          if (variantId && variant) {
            store.dispatch(openCart());
            store.dispatch(addItem(variantId, 1, variant, null, measurements));
          }
          
          return false;
        }
        targetElement = targetElement.parentElement;
      }
    });
  }
};